import React from 'react'
import ReactSelect from 'react-select'
import { SelectStyle } from './style'
import { OptionItem } from './style'

const CustomOption = (props) => {
	const {
		children,
		className,
		cx,
		data,
		isFocused,
		isSelected,
		innerProps,
	} = props

	return (
		<OptionItem
			disabled={data.outOfStock}
			className={cx(
				{
					option: true,
					'option--is-disabled': data.outOfStock, //isDisabled,
					'option--is-focused': isFocused,
					'option--is-selected': isSelected,
				},
				className
			)}
			{...innerProps}
		>
			{children}
			{data.outOfStock && ' - Out of Stock'}
		</OptionItem>
	)
}

const Select = (props) => {
	let { isEmpty = false } = props
	return (
		<SelectStyle isEmpty={isEmpty}>
			<ReactSelect
				{...props}
				components={{ Option: CustomOption }}
				classNamePrefix='react-select'
				//menuIsOpen={true}
			/>
		</SelectStyle>
	)
}

export default Select
